import { create } from "zustand";
import { UUID } from "../utils/typeDefinitions";

interface UserState {
    currentUserId: UUID | null;
    isUserLoaded: boolean;
    canEditRoomNotes: boolean;
    setCurrentUserId: (id: UUID | null) => void;
    setCanEditRoomNotes: (canEdit: boolean) => void;
}

export const useUserStateStore = create<UserState>((set) => ({
    currentUserId: null,
    isUserLoaded: false,
    canEditRoomNotes: false,
    setCurrentUserId: (id) => set({ currentUserId: id, isUserLoaded: true }),
    setCanEditRoomNotes: (canEdit) => set({ canEditRoomNotes: canEdit }),
}));
